"use client";

import { useState } from "react";
import { useForm } from "react-hook-form";

import {
  AlertDialog,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
  Button,
  Textarea,
} from "@stocks/ui";

import { useCancelOrder } from "../model/useCancelOrder";

/** 발주 취소 버튼 (사유 입력 후 확인). 취소 후에도 기록은 남는다. */
export const CancelOrderButton = ({
  orderId,
  orderNo,
  onCancelled,
}: {
  orderId: string;
  orderNo: string;
  onCancelled?: () => void;
}) => {
  const [open, setOpen] = useState(false);
  const { register, handleSubmit, reset } = useForm<{ reason: string }>({
    defaultValues: { reason: "" },
  });
  const cancel = useCancelOrder();

  const onSubmit = async ({ reason }: { reason: string }) => {
    await cancel.mutateAsync({ id: orderId, reason: reason.trim() || undefined });
    reset();
    setOpen(false);
    onCancelled?.();
  };

  return (
    <AlertDialog open={open} onOpenChange={setOpen}>
      <AlertDialogTrigger asChild>
        <Button type='button' variant='destructive'>
          발주 취소
        </Button>
      </AlertDialogTrigger>
      <AlertDialogContent>
        <form onSubmit={handleSubmit(onSubmit)} className='flex flex-col gap-4'>
          <AlertDialogHeader>
            <AlertDialogTitle>발주 {orderNo} 를 취소할까요?</AlertDialogTitle>
            <AlertDialogDescription>
              취소해도 발주 기록은 &apos;취소&apos; 상태로 보존됩니다.
            </AlertDialogDescription>
          </AlertDialogHeader>
          <Textarea
            aria-label='취소 사유'
            placeholder='취소 사유 (선택)'
            {...register("reason")}
          />
          <AlertDialogFooter>
            <AlertDialogCancel type='button'>닫기</AlertDialogCancel>
            <Button type='submit' variant='destructive' disabled={cancel.isPending}>
              {cancel.isPending ? "취소 중…" : "발주 취소"}
            </Button>
          </AlertDialogFooter>
        </form>
      </AlertDialogContent>
    </AlertDialog>
  );
};
